export default __webpack_public_path__ + "static/media/microsof-excel-logo.996d664d.png";